import { openDefectInDialog, emitDefectFlyTo } from './defectActions.js';

export const DASHBOARD_DEFECT_TOGGLE_EVENT = 'toggle-defect-drawer';
export const DASHBOARD_DEFECT_FLY_TO_EVENT = 'defect-fly-to-coordinate';
export const DASHBOARD_DEFECT_VIEW_MODE_EVENT = 'dashboard-defect-view-mode';
/**
 * 대시보드 결함 drawer·이벤트 버스 연동 (한 번 install → teardown으로 제거)
 *
 * @param {object} vm — DashboardPage
 * @param {object} [options]
 * @param {import('vuex').Store} [options.store]
 * @returns {() => void}
 */
export function installDashboardDefectFeature(vm, options = {}) {
  const store = options.store ?? vm.$store;
  const eventBus = vm.$eventBus;

  const onToggleDrawer = () => {
    vm.showDefectDrawer = !vm.showDefectDrawer;
  };

  const onViewMode = ({ mode }) => {
    if (mode === 'module') {
      vm.showDefectDrawer = true;
    } else {
      vm.showDefectDrawer = false;
    }
  };

  eventBus.$on(DASHBOARD_DEFECT_TOGGLE_EVENT, onToggleDrawer);
  eventBus.$on(DASHBOARD_DEFECT_VIEW_MODE_EVENT, onViewMode);

  return () => {
    eventBus.$off(DASHBOARD_DEFECT_TOGGLE_EVENT, onToggleDrawer);
    eventBus.$off(DASHBOARD_DEFECT_VIEW_MODE_EVENT, onViewMode);
  };
}

/** drawer 행 클릭 → 수정 모달 (모듈 모드: 좌우 네비 = 같은 모듈 결함) */
export async function handleDashboardDefectSelect(vm, defect, options = {}) {
  const store = options.store ?? vm.$store;
  return openDefectInDialog(store, defect, {
    navigationMode: 'module',
    allModuleDefects: vm.dashboardDefects
  });
}

/** drawer 지도 이동 버튼 */
export function handleDashboardDefectFlyTo(vm, defect) {
  emitDefectFlyTo(vm.$store, defect);
}
